import type { PermissionAction, PermissionResource } from '@admin/libraries/access_control_catalog.generated';

export const permissionKey = (resource: PermissionResource, action: PermissionAction): string =>
  `${resource}:${action}`;

export const hasPermission = (
  key: string,
  grantedPermissions: readonly string[] = currentGrantedPermissions(),
): boolean => grantedPermissions.includes(key);

export const hasResourceAction = (
  resource: PermissionResource,
  action: PermissionAction,
  grantedPermissions: readonly string[] = currentGrantedPermissions(),
): boolean => hasPermission(permissionKey(resource, action), grantedPermissions);

function currentGrantedPermissions(): readonly string[] {
  return window.clutter?.user?.granted_permissions ?? [];
}
